import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SnackbarMessageComponent } from 'src/app/components/snackbar-message/snackbar-message.component';
import { DataService } from 'src/app/services/data.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';
import { fadeOp, fadeOpInOut } from 'src/app/util/animations.util';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: [
    '../../../sign-in/components/sign-in/sign-in.component.css',
    './forget-password.component.css'
  ],
  animations: [
    fadeOp,
    fadeOpInOut
  ]
})
export class ForgetPasswordComponent implements OnInit {
  resendSnackbar: boolean = false;
  userEmail: string;
  responseMSG: string; 
  // isSuccess: boolean = false; 
  version = ''
  emailControl: FormControl = new FormControl("", [Validators.required, Validators.email]);
  resetPasswordForm: FormGroup = new FormGroup({
    email: this.emailControl
  });


  constructor(
    private userService: UserService,
    private dataService: DataService,
    private utility: UtilityService,
    private router: Router,
    private snackbar: MatSnackBar,
    private _loadingService: LoadingService
  ) { }

  ngOnInit() {
      this.version = this.dataService.getVersion()
  }
  reSubmit(): void {
    // this.resendSnackbar = true;
    this.onSubmit();
  }
  onSubmit(): void {
      if (this.resetPasswordForm.invalid) return this.resetPasswordForm.markAllAsTouched();
      this._loadingService._setLoading();
      this.userService.forgotPassword(this.resetPasswordForm.value.email)
      .then(() => {
        this._loadingService._clearLoading();
        localStorage.setItem('reset-password-email', this.resetPasswordForm.value.email);
        this.router.navigateByUrl('/auth/forgot-password/verify');
      })
      .catch((response) => {
        this._loadingService._clearLoading();
        if (!response) return;
        if (response.message == "Email is invalid")
          this.emailControl.setErrors({
            email: true
          });
        if (this.resendSnackbar) {
          this.snackbar.openFromComponent(SnackbarMessageComponent, {
            data: {
              message: 'MSG.FAILED'
            },
            panelClass: 'bg-warn',
            duration: 1500
          });
          this.resendSnackbar = false;
        }
      })
  }
  changeLang(lang: string): void {
    this.utility.changeLang(lang);
  }
  get availableLangs(): string[] {
    return this.utility.getAvailableLang()
  }

  get currentLang(): string {
    return this.utility.getLang();
  }

  textboxChanged() {
      this.responseMSG = null;
  }

  handleResponse(data: string) {
      let obj = JSON.parse(data);
      if (obj['status'] != 1) {
          this.responseMSG = obj['message'];
      } else {    
        this.responseMSG = 'MSG.SENT_PASSWORD_RESET'; 
        this.userEmail="";
      }
  }

}
